/**
 * PackagePayload → next FlowOptimizerConfig draft. A package is formulas +
 * rules, not schedule identity: mode is forced to CUSTOM, while intervalMin,
 * min/maxWeight, standardJson, enabled and killSwitch stay untouched.
 * NOTHING is saved here — the caller feeds the result into the draft and the
 * live preview; Save Config persists.
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FlowOptimizerConfig } from '@trafficpulse/shared';

import { replaceFormulaFromPayload } from '@/features/flow-optimizer/clipboard/formula-clipboard.apply';

import { applyRuleSetPayload } from './apply-rule-set';
import type { PackagePayload } from './library-payload.types';

export function applyPackageToDraft(opts: {
  draft: FlowOptimizerConfig;
  payload: PackagePayload;
  /** Bank ids the target flow has — stale per-path skips are dropped. */
  knownBankIds?: ReadonlySet<string>;
}): FlowOptimizerConfig {
  const rules = applyRuleSetPayload(opts.payload.rules);
  return {
    ...opts.draft,
    mode: 'CUSTOM',
    formula: replaceFormulaFromPayload(opts.payload.formula, opts.knownBankIds),
    excludeRules: rules.excludeRules,
    capacityRules: rules.capacityRules,
  };
}
